'use strict';

module.exports = [
// type
require('./Chain'),

// construction function
require('./function/chain')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/chain/index.js
// module id = 9Gdr
// module chunks = 0